import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/supporter/$supporterId/eap/requests/$requestId")({
  component: lazyRouteComponent(() => import("./+Request")),
});
